export const LogoutIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.7 18.562H12.5917C8.89167 18.562 7.10834 17.1036 6.8 13.837C6.76667 13.4953 7.01667 13.187 7.36667 13.1536C7.7 13.1203 8.01667 13.3786 8.05 13.7203C8.29167 16.337 9.525 17.312 12.6 17.312H12.7083C16.1 17.312 17.3 16.112 17.3 12.7203V7.28698C17.3 3.89531 16.1 2.69531 12.7083 2.69531H12.6C9.50834 2.69531 8.275 3.68698 8.05 6.35365C8.00834 6.69531 7.71667 6.95365 7.36667 6.92031C7.01667 6.89531 6.76667 6.58698 6.79167 6.24531C7.075 2.92865 8.86667 1.44531 12.5917 1.44531H12.7C16.7917 1.44531 18.5417 3.19531 18.5417 7.28698V12.7203C18.5417 16.812 16.7917 18.562 12.7 18.562Z"
      fill="currentColor"
    />
    <path
      d="M12.5 10.6289H3.01666C2.675 10.6289 2.39166 10.3456 2.39166 10.0039C2.39166 9.66224 2.675 9.37891 3.01666 9.37891H12.5C12.8417 9.37891 13.125 9.66224 13.125 10.0039C13.125 10.3456 12.8417 10.6289 12.5 10.6289Z"
      fill="currentColor"
    />
    <path
      d="M4.875 13.4211C4.71667 13.4211 4.55834 13.3628 4.43334 13.2378L1.64167 10.4461C1.4 10.2044 1.4 9.80443 1.64167 9.56276L4.43334 6.77109C4.675 6.52943 5.075 6.52943 5.31667 6.77109C5.55833 7.01276 5.55833 7.41276 5.31667 7.65443L2.96667 10.0044L5.31667 12.3544C5.55833 12.5961 5.55833 12.9961 5.31667 13.2378C5.2 13.3628 5.03333 13.4211 4.875 13.4211Z"
      fill="currentColor"
    />
  </svg>
);

export const DashboardIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.6691 5.41471C15.5185 5.41471 14.5858 4.48197 14.5858 3.33138C14.5858 2.18079 15.5185 1.24805 16.6691 1.24805C17.8197 1.24805 18.7524 2.18079 18.7524 3.33138C18.7524 4.48197 17.8197 5.41471 16.6691 5.41471ZM16.6691 4.16471C16.2089 4.16471 15.8358 3.79161 15.8358 3.33138C15.8358 2.87115 16.2089 2.49805 16.6691 2.49805C17.1294 2.49805 17.5024 2.87115 17.5024 3.33138C17.5024 3.79161 17.1294 4.16471 16.6691 4.16471ZM12.5024 3.12305C12.8476 3.12305 13.1274 2.84322 13.1274 2.49805C13.1274 2.15287 12.8476 1.87305 12.5024 1.87305H9.96477C8.43427 1.87304 7.23462 1.87304 6.28284 1.97616C5.31156 2.08139 4.52457 2.29998 3.85264 2.78817C3.44585 3.08372 3.08812 3.44146 2.79257 3.84824C2.30437 4.52018 2.08578 5.30716 1.98055 6.27845C1.87743 7.23022 1.87743 8.42988 1.87744 9.96038V10.0357C1.87743 11.5662 1.87743 12.7659 1.98055 13.7176C2.08578 14.689 2.30437 15.4759 2.79257 16.1479C3.08812 16.5546 3.44585 16.9124 3.85263 17.2079C4.52457 17.6961 5.31156 17.9147 6.28284 18.02C7.2346 18.123 8.43428 18.123 9.96469 18.123H10.0402C11.5706 18.123 12.7703 18.123 13.722 18.02C14.6934 17.9147 15.4803 17.6961 16.1523 17.2079C16.559 16.9124 16.9168 16.5546 17.2123 16.1479C17.7005 15.4759 17.9191 14.689 18.0244 13.7176C18.1274 12.7659 18.1274 11.5662 18.1274 10.0358V7.49805C18.1274 7.15287 17.8476 6.87305 17.5024 6.87305C17.1573 6.87305 16.8774 7.15287 16.8774 7.49805V9.99805C16.8774 11.5744 16.8766 12.7064 16.7816 13.583C16.6879 14.448 16.5086 14.9898 16.201 15.4131C15.9826 15.7138 15.7182 15.9782 15.4175 16.1966C14.9942 16.5042 14.4524 16.6835 13.5874 16.7772C12.7108 16.8722 11.5788 16.873 10.0024 16.873C8.42611 16.873 7.2941 16.8722 6.41747 16.7772C5.55255 16.6835 5.01071 16.5042 4.58737 16.1966C4.2867 15.9782 4.02229 15.7138 3.80384 15.4131C3.49627 14.9898 3.31698 14.448 3.22327 13.583C3.1283 12.7064 3.12744 11.5744 3.12744 9.99805C3.12744 8.42171 3.1283 7.28971 3.22327 6.41309C3.31698 5.54815 3.49627 5.00631 3.80384 4.58297C4.02229 4.28231 4.2867 4.0179 4.58737 3.79945C5.01071 3.49187 5.55255 3.31259 6.41748 3.21888C7.2941 3.12391 8.42611 3.12305 10.0024 3.12305H12.5024ZM5.27465 12.1037C5.12263 12.4136 5.25063 12.7881 5.56053 12.9401C5.87043 13.0921 6.24488 12.9641 6.3969 12.6542L7.61385 10.1734C7.99104 9.40438 9.09969 9.44196 9.42394 10.2347C10.1566 12.0255 12.6611 12.1104 13.5133 10.3732L14.7303 7.89235C14.8823 7.58244 14.7543 7.20798 14.4444 7.05597C14.1344 6.90396 13.76 7.03195 13.6079 7.34185L12.391 9.82271C12.0139 10.5917 10.9052 10.5541 10.5809 9.76138C9.84828 7.97053 7.34373 7.88569 6.49159 9.62288L5.27465 12.1037Z"
      fill="currentColor"
    />
  </svg>
);

export const LinkIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.04705 9.32575C8.05056 9.32785 8.05422 9.33007 8.05804 9.33241C8.12709 9.37473 8.14876 9.46501 8.10643 9.53406L8.09656 9.54822L8.0851 9.56112L7.66974 9.97645C7.64617 10 7.62342 10.0228 7.60151 10.0447L7.42651 10.2197C7.41447 10.2317 7.39979 10.2464 7.38246 10.2637C7.33568 10.3105 7.26565 10.3252 7.20401 10.3011C7.17999 10.2918 7.1596 10.2844 7.14283 10.2791C6.73466 10.15 6.27326 10.2357 5.93579 10.5362L5.88242 10.5866L4.11669 12.3523C3.64651 12.8225 3.62972 13.5744 4.06632 14.0647L4.11669 14.1181L5.88242 15.8838C6.35259 16.354 7.10447 16.3708 7.59477 15.9342L7.64814 15.8838L9.41387 14.1181C9.61749 13.9144 9.73608 13.658 9.76963 13.3928C9.77447 13.3546 9.77717 13.3016 9.77775 13.2337C9.77813 13.19 9.79566 13.1482 9.82656 13.1173L10.6488 12.2949C10.6997 12.244 10.7822 12.244 10.8331 12.2949C10.8457 12.3075 10.8556 12.3226 10.8622 12.3391C10.8677 12.3531 10.8726 12.3659 10.8768 12.3774C11.1995 13.2615 11.0061 14.2915 10.2967 15.0009L8.531 16.7667C7.55582 17.7418 5.97474 17.7418 4.99955 16.7667L3.23383 15.0009C2.25865 14.0258 2.25865 12.4447 3.23383 11.4695L4.99955 9.70376C5.82607 8.87724 7.08783 8.75124 8.04705 9.32575ZM12.3274 7.32017L12.9746 7.96733C13.0397 8.03241 13.0397 8.13794 12.9746 8.20303L8.20742 12.9702C8.14234 13.0353 8.03681 13.0353 7.97172 12.9702L7.32456 12.3231C7.25947 12.258 7.25947 12.1524 7.32456 12.0874L12.0917 7.32017C12.1568 7.25508 12.2624 7.25508 12.3274 7.32017ZM15.0053 3.22943L16.7711 4.99516C17.7462 5.97034 17.7462 7.55143 16.7711 8.52661L15.0053 10.2923C14.2999 10.9977 13.2775 11.1929 12.3967 10.8778C12.377 10.8707 12.3538 10.8618 12.3272 10.851C12.2661 10.8263 12.2367 10.7567 12.2614 10.6957L12.2725 10.6746L12.2876 10.6561L12.6376 10.3063C12.6899 10.254 12.7391 10.2048 12.7853 10.1586L12.9728 9.9712C12.9914 9.95265 13.0092 9.93485 13.0263 9.91781C13.0496 9.89442 13.0816 9.86252 13.122 9.82211C13.1529 9.79123 13.1946 9.77371 13.2383 9.77331C13.3077 9.77267 13.3619 9.76982 13.4009 9.76477C13.6421 9.73353 13.8759 9.63189 14.0691 9.45985L14.1225 9.40947L15.8882 7.64375C16.3584 7.17357 16.3752 6.42169 15.9386 5.9314L15.8882 5.87802L14.1225 4.1123C13.6523 3.64212 12.9004 3.62533 12.4101 4.06192L12.3567 4.1123L10.591 5.87802C10.2491 6.21997 10.1469 6.71091 10.2846 7.14187C10.2897 7.15772 10.2966 7.1769 10.3054 7.19939C10.3294 7.26101 10.3148 7.33102 10.268 7.37781L10.0611 7.58483C10.0289 7.61701 9.99403 7.65191 9.95644 7.68952L9.76894 7.87711C9.7232 7.92288 9.67475 7.97135 9.62358 8.02255L9.54479 8.10138C9.49657 8.14963 9.41837 8.14965 9.37012 8.10143C9.3636 8.09491 9.35783 8.08769 9.35293 8.07989C9.35052 8.07607 9.34826 8.07242 9.34613 8.06896C8.75338 7.10661 8.87406 5.82925 9.70815 4.99516L11.4739 3.22943C12.4491 2.25425 14.0301 2.25425 15.0053 3.22943Z"
      fill="currentColor"
    />
  </svg>
);

export const StudioIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.49988 12.1211C6.15821 12.1211 5.87488 11.8377 5.87488 11.4961V7.99609C5.87488 7.65443 6.15821 7.37109 6.49988 7.37109C6.84154 7.37109 7.12488 7.65443 7.12488 7.99609V11.4961C7.12488 11.8377 6.84154 12.1211 6.49988 12.1211Z"
      fill="currentColor"
    />
    <path
      d="M6.62501 15.6211C5.38334 15.6211 4.375 14.6127 4.375 13.3711C4.375 12.1294 5.38334 11.1211 6.62501 11.1211C7.86668 11.1211 8.87502 12.1294 8.87502 13.3711C8.87502 14.6127 7.86668 15.6211 6.62501 15.6211ZM6.62501 12.3711C6.07501 12.3711 5.625 12.8211 5.625 13.3711C5.625 13.9211 6.07501 14.3711 6.62501 14.3711C7.17501 14.3711 7.62502 13.9211 7.62502 13.3711C7.62502 12.8211 7.17501 12.3711 6.62501 12.3711Z"
      fill="currentColor"
    />
    <path
      d="M6.49999 8.6211C5.32499 8.6211 4.375 7.67108 4.375 6.49608C4.375 5.32108 5.32499 4.37109 6.49999 4.37109C7.67499 4.37109 8.62498 5.32108 8.62498 6.49608C8.62498 7.67108 7.67499 8.6211 6.49999 8.6211ZM6.49999 5.62109C6.01666 5.62109 5.625 6.01275 5.625 6.49608C5.625 6.97942 6.01666 7.3711 6.49999 7.3711C6.98332 7.3711 7.37498 6.97942 7.37498 6.49608C7.37498 6.01275 6.98332 5.62109 6.49999 5.62109Z"
      fill="currentColor"
    />
    <path
      d="M13.4999 8.6211C12.3249 8.6211 11.3749 7.67108 11.3749 6.49608C11.3749 5.32108 12.3249 4.37109 13.4999 4.37109C14.6749 4.37109 15.6249 5.32108 15.6249 6.49608C15.6249 7.67108 14.6749 8.6211 13.4999 8.6211ZM13.4999 5.62109C13.0165 5.62109 12.6249 6.01275 12.6249 6.49608C12.6249 6.97942 13.0165 7.3711 13.4999 7.3711C13.9832 7.3711 14.3749 6.97942 14.3749 6.49608C14.3749 6.01275 13.9832 5.62109 13.4999 5.62109Z"
      fill="currentColor"
    />
    <path
      d="M6.56678 12.122C6.51678 12.122 6.45845 12.1137 6.40845 12.1054C6.07511 12.022 5.87513 11.6803 5.95847 11.347C6.25847 10.172 7.31676 9.36368 8.5251 9.36368H8.53344L10.2501 9.37202H10.2584C11.2668 9.37202 12.1584 8.73869 12.4918 7.78869C12.6084 7.46369 12.9668 7.2887 13.2834 7.40537C13.6084 7.52203 13.7835 7.87203 13.6668 8.20536C13.1585 9.66369 11.7918 10.6387 10.2418 10.6304L8.5251 10.622C8.5251 10.622 8.52509 10.622 8.51675 10.622C7.87509 10.622 7.3168 11.0554 7.15847 11.672C7.10013 11.9387 6.84178 12.122 6.56678 12.122Z"
      fill="currentColor"
    />
    <path
      d="M12.5 18.9538H7.49996C2.97496 18.9538 1.04163 17.0204 1.04163 12.4954V7.49544C1.04163 2.97044 2.97496 1.03711 7.49996 1.03711H12.5C17.025 1.03711 18.9583 2.97044 18.9583 7.49544V12.4954C18.9583 17.0204 17.025 18.9538 12.5 18.9538ZM7.49996 2.28711C3.65829 2.28711 2.29163 3.65378 2.29163 7.49544V12.4954C2.29163 16.3371 3.65829 17.7038 7.49996 17.7038H12.5C16.3416 17.7038 17.7083 16.3371 17.7083 12.4954V7.49544C17.7083 3.65378 16.3416 2.28711 12.5 2.28711H7.49996Z"
      fill="currentColor"
    />
  </svg>
);

export const AuditIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M6 2H18C19.1 2 20 2.9 20 4V20C20 21.1 19.1 22 18 22H6C4.9 22 4 21.1 4 20V4C4 2.9 4.9 2 6 2Z" />
    <path d="M8 6H14" fill="currentColor" />
    <path d="M8 10H12" fill="currentColor" />
    <circle cx="13.5" cy="15.5" r="3" />
    <path d="M15.5 17.5L17.5 19.5" fill="currentColor" />
  </svg>
);

export const SettingIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.3622 1.70249C12.3751 1.70638 12.3865 1.70988 12.3965 1.713C13.7227 2.12484 14.9099 2.86997 15.868 3.85464C15.8794 3.8664 15.8931 3.88062 15.909 3.8973L15.909 3.89733C15.959 3.94965 15.9695 4.02824 15.935 4.09184C15.9199 4.11976 15.9075 4.14332 15.898 4.16252C15.5232 4.91977 15.5154 5.85281 15.9563 6.64487C16.3821 7.4098 17.127 7.86458 17.9159 7.93278C17.9319 7.93417 17.9511 7.93546 17.9735 7.93668L17.9735 7.93672C18.0481 7.94075 18.1109 7.99397 18.1272 8.06691C18.135 8.10193 18.1413 8.13122 18.1463 8.15476C18.2705 8.74736 18.3357 9.3628 18.3357 9.99405C18.3357 10.7932 18.2312 11.5669 18.0355 12.3015C18.0304 12.3203 18.0241 12.3435 18.0165 12.3709L18.0165 12.3709C17.9981 12.4374 17.9407 12.4856 17.872 12.4923C17.8596 12.4935 17.8487 12.4947 17.8391 12.4958C17.0788 12.5857 16.3683 13.0354 15.9563 13.7754C15.5728 14.4643 15.5288 15.2598 15.7704 15.9537C15.7793 15.9794 15.7917 16.0121 15.8075 16.0518L15.8075 16.0518C15.8322 16.1137 15.8176 16.1843 15.7705 16.2314C15.7468 16.255 15.7271 16.2745 15.7113 16.29C14.7646 17.2142 13.609 17.9111 12.3257 18.2967C12.2748 18.312 12.2049 18.3318 12.1161 18.356L12.1161 18.356C12.0512 18.3737 11.9821 18.3507 11.9408 18.2977C11.9102 18.2585 11.8849 18.2272 11.8647 18.2038C11.4068 17.6738 10.7421 17.3406 10.0024 17.3406C9.28527 17.3406 8.63866 17.6538 8.18277 18.1555C8.15203 18.1893 8.11256 18.2368 8.06435 18.298L8.06432 18.298C8.02295 18.3506 7.95418 18.3733 7.88965 18.3557C7.79822 18.3308 7.7264 18.3105 7.67419 18.2948C6.38917 17.9082 5.23234 17.209 4.28495 16.282C4.27115 16.2685 4.25417 16.2517 4.23401 16.2315L4.234 16.2316C4.18679 16.1844 4.17225 16.1136 4.19705 16.0517C4.20906 16.0217 4.21869 15.9966 4.22594 15.9764C4.47693 15.2773 4.43616 14.4718 4.04848 13.7754C3.66032 13.0781 3.00705 12.6385 2.29697 12.5146C2.25611 12.5074 2.20121 12.5003 2.13228 12.4931L2.13228 12.4931C2.06417 12.486 2.00732 12.4379 1.98899 12.372C1.98013 12.3401 1.97288 12.3135 1.96721 12.2922C1.77279 11.5607 1.66907 10.7899 1.66907 9.99405C1.66907 9.33249 1.74073 8.6883 1.87644 8.06936C1.87659 8.06867 1.87675 8.06797 1.8769 8.06726L1.87691 8.06726C1.893 7.9941 1.95591 7.94066 2.03071 7.93663C2.04679 7.93576 2.06089 7.93484 2.07299 7.93388C2.86804 7.87053 3.61988 7.41481 4.04848 6.64487C4.46743 5.89224 4.48125 5.01232 4.16011 4.27677C4.13974 4.2301 4.1092 4.16846 4.0685 4.09184L4.0685 4.09185C4.03473 4.02827 4.04559 3.95019 4.09544 3.89825C4.15229 3.83901 4.19794 3.79224 4.23238 3.75796C5.13844 2.85589 6.24083 2.16412 7.46645 1.75849C7.51065 1.74386 7.56962 1.7253 7.64335 1.70282L7.64335 1.7028C7.71864 1.67984 7.79974 1.71269 7.83783 1.78158C7.87044 1.84054 7.89787 1.88736 7.92014 1.92204C8.36827 2.61994 9.13358 3.07961 10.0024 3.07961C10.9096 3.07961 11.704 2.57839 12.1421 1.82836C12.1469 1.82013 12.1553 1.80498 12.1672 1.78291L12.1672 1.78292C12.2048 1.71314 12.2864 1.67951 12.3622 1.70249ZM12.624 3.26819C11.9373 3.96445 11.0044 4.37607 10.0024 4.37607C9.01173 4.37607 8.08985 3.97371 7.40648 3.29388L7.38291 3.26964C7.33994 3.22546 7.27418 3.21235 7.21755 3.23667C6.64085 3.49273 6.0998 3.82758 5.60829 4.2314L5.5802 4.25508C5.53135 4.29629 5.51037 4.36181 5.52619 4.42373L5.5264 4.42455C5.74097 5.33449 5.63597 6.31199 5.19612 7.17118L5.13101 7.29309C4.66577 8.12885 3.93357 8.73433 3.0893 9.03139C3.08611 9.03252 3.08146 9.0341 3.07533 9.03614L3.07533 9.03614C3.01371 9.0567 2.96965 9.1112 2.96245 9.17576C2.96177 9.18183 2.96123 9.18682 2.96082 9.19072C2.94071 9.38288 2.92782 9.57656 2.92225 9.77146L2.91907 9.99405C2.91907 10.3974 2.9503 10.7959 3.01181 11.1868L3.02723 11.277C3.03737 11.336 3.07839 11.3851 3.13471 11.4055C3.16776 11.4175 3.19353 11.4272 3.21202 11.4344C3.96718 11.7308 4.62277 12.2771 5.06531 13.0136L5.13101 13.1272C5.5622 13.9018 5.71469 14.7854 5.59384 15.6362C5.59371 15.637 5.59357 15.6381 5.59339 15.6392H5.5934C5.58478 15.6972 5.60726 15.7555 5.65259 15.7926C5.66055 15.7991 5.66605 15.8036 5.6691 15.8061C6.22573 16.2533 6.84351 16.6124 7.5029 16.8702C7.5099 16.873 7.52321 16.878 7.54283 16.8854L7.54284 16.8854C7.59831 16.9061 7.66063 16.8959 7.70655 16.8585C7.72769 16.8413 7.7418 16.8299 7.74886 16.8244C8.35398 16.3521 9.09191 16.0739 9.87437 16.0464L10.0024 16.0442C10.8585 16.0442 11.6675 16.3446 12.316 16.8724L12.3201 16.8758C12.352 16.9025 12.3956 16.9103 12.4348 16.8964C13.1135 16.639 13.749 16.2749 14.3203 15.8183C14.3257 15.814 14.3364 15.8052 14.3526 15.792L14.3526 15.792C14.3979 15.7548 14.4203 15.6966 14.4117 15.6386C14.4066 15.6044 14.4034 15.582 14.4021 15.5716C14.3034 14.7841 14.438 13.9717 14.8101 13.2462L14.8738 13.1272C15.32 12.3256 16.0123 11.7347 16.8154 11.4258L16.8695 11.4063C16.9259 11.386 16.967 11.337 16.9773 11.278L16.993 11.187C17.0422 10.874 17.072 10.5564 17.082 10.2354L17.0857 9.99405C17.0857 9.71935 17.0713 9.44698 17.0426 9.17774C17.0425 9.17737 17.0425 9.17698 17.0424 9.17658L17.0424 9.17658C17.0354 9.11206 16.9916 9.05745 16.9302 9.03664C16.9289 9.0362 16.9278 9.03582 16.9268 9.03549C16.1171 8.75349 15.4096 8.18814 14.9404 7.4082L14.8738 7.29309C14.3795 6.40516 14.2536 5.37764 14.4785 4.42439L14.4789 4.42289C14.4943 4.36117 14.4732 4.29605 14.4246 4.25506L14.3966 4.23148C13.905 3.82761 13.364 3.49275 12.7873 3.23668L12.7837 3.23518C12.7288 3.21179 12.6651 3.22494 12.624 3.26819ZM10.0024 6.96898C11.6132 6.96898 12.9191 8.32335 12.9191 9.99405C12.9191 11.6647 11.6132 13.0191 10.0024 13.0191C8.39157 13.0191 7.08573 11.6647 7.08573 9.99405C7.08573 8.32335 8.39157 6.96898 10.0024 6.96898ZM10.0024 8.26544C9.08193 8.26544 8.33573 9.03936 8.33573 9.99405C8.33573 10.9487 9.08193 11.7227 10.0024 11.7227C10.9229 11.7227 11.6691 10.9487 11.6691 9.99405C11.6691 9.03936 10.9229 8.26544 10.0024 8.26544Z"
      fill="currentColor"
    />
  </svg>
);

export const DocumentIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2.91663 15.6204C2.57496 15.6204 2.29163 15.3371 2.29163 14.9954V5.82878C2.29163 2.15378 3.40829 1.03711 7.08329 1.03711H12.9166C16.5916 1.03711 17.7083 2.15378 17.7083 5.82878V14.1621C17.7083 14.2954 17.7083 14.4204 17.7 14.5538C17.675 14.8954 17.3666 15.1621 17.0333 15.1371C16.6916 15.1121 16.425 14.8121 16.45 14.4704C16.4583 14.3704 16.4583 14.2621 16.4583 14.1621V5.82878C16.4583 2.85378 15.9 2.28711 12.9166 2.28711H7.08329C4.09996 2.28711 3.54163 2.85378 3.54163 5.82878V14.9954C3.54163 15.3371 3.25829 15.6204 2.91663 15.6204Z"
      fill="currentColor"
    />
    <path
      d="M14.1666 18.9544H5.83329C3.88329 18.9544 2.29163 17.3628 2.29163 15.4128V14.8711C2.29163 13.2128 3.64163 11.8711 5.29163 11.8711H17.0833C17.425 11.8711 17.7083 12.1544 17.7083 12.4961V15.4128C17.7083 17.3628 16.1166 18.9544 14.1666 18.9544ZM5.29163 13.1211C4.32496 13.1211 3.54163 13.9044 3.54163 14.8711V15.4128C3.54163 16.6794 4.56663 17.7044 5.83329 17.7044H14.1666C15.4333 17.7044 16.4583 16.6794 16.4583 15.4128V13.1211H5.29163Z"
      fill="currentColor"
    />
    <path
      d="M13.3333 6.45508H6.66663C6.32496 6.45508 6.04163 6.17174 6.04163 5.83008C6.04163 5.48841 6.32496 5.20508 6.66663 5.20508H13.3333C13.675 5.20508 13.9583 5.48841 13.9583 5.83008C13.9583 6.17174 13.675 6.45508 13.3333 6.45508Z"
      fill="currentColor"
    />
    <path
      d="M10.8333 9.37109H6.66663C6.32496 9.37109 6.04163 9.08776 6.04163 8.74609C6.04163 8.40443 6.32496 8.12109 6.66663 8.12109H10.8333C11.175 8.12109 11.4583 8.40443 11.4583 8.74609C11.4583 9.08776 11.175 9.37109 10.8333 9.37109Z"
      fill="currentColor"
    />
  </svg>
);

export const VerifiedIcon = ({ fill = "currentColor", size = 24 }) => (
  <svg xmlns="http://www.w3.org/2000/svg" height={size} viewBox="0 -960 960 960" width={size} fill={fill}>
    <path d="m344-60-76-128-144-32 14-148-98-112 98-112-14-148 144-32 76-128 136 58 136-58 76 128 144 32-14 148 98 112-98 112 14 148-144 32-76 128-136-58-136 58Zm94-278 226-226-56-58-170 170-86-84-56 56 142 142Z" />
  </svg>
);

export const ErrorIcon = ({ fill = "#f5365c", size = 52 }) => (
  <svg xmlns="http://www.w3.org/2000/svg" height={size} viewBox="0 -960 960 960" width={size}>
    <path fill="white" d="M330-120 120-330v-300l210-210h300l210 210v300L630-120H330Z" />
    <path
      fill={fill}
      d="M480-280q17 0 28.5-11.5T520-320q0-17-11.5-28.5T480-360q-17 0-28.5 11.5T440-320q0 17 11.5 28.5T480-280Zm-40-160h80v-240h-80v240ZM330-120 120-330v-300l210-210h300l210 210v300L630-120H330Z"
    />
  </svg>
);

export const LanguageIcon = ({ fill = "#5e72e4", size = 20 }) => (
  <svg xmlns="http://www.w3.org/2000/svg" height={size} viewBox="0 -960 960 960" width={size} fill={fill}>
    <path d="m476-80 182-480h84L924-80h-84l-43-122H603L560-80h-84ZM160-200l-56-56 202-202q-35-35-63.5-80T190-640h84q20 39 40 68t48 58q33-33 68.5-92.5T484-720H40v-80h280v-80h80v80h280v80H564q-21 72-63 148t-83 116l96 98-30 82-122-125-202 201Zm468-72h144l-72-204-72 204Z" />
  </svg>
);

export const TargetIcon = ({ fill = "currentColor", size = 16 }) => (
  <svg xmlns="http://www.w3.org/2000/svg" height={size} viewBox="0 -960 960 960" width={size} fill={fill}>
    <path d="M480.28-96Q401-96 331-126t-122.5-82.5Q156-261 126-330.96t-30-149.5Q96-560 126-629.5q30-69.5 82.5-122T330.96-834q69.96-30 149.5-30t149.04 30q69.5 30 122 82.5T834-629.28q30 69.73 30 149Q864-401 834-331t-82.5 122.5Q699-156 629.28-126q-69.73 30-149 30Zm-.28-72q130 0 221-91t91-221q0-130-91-221t-221-91q-130 0-221 91t-91 221q0 130 91 221t221 91Zm0-72q-100 0-170-70t-70-170q0-100 70-170t170-70q100 0 170 70t70 170q0 100-70 170t-170 70Zm0-72q70 0 119-49t49-119q0-70-49-119t-119-49q-70 0-119 49t-49 119q0 70 49 119t119 49Zm-.21-96Q450-408 429-429.21t-21-51Q408-510 429.21-531t51-21Q510-552 531-530.79t21 51Q552-450 530.79-429t-51 21Z" />
  </svg>
);

export const StarCircleIcon = ({ fill = "currentColor", size = 16 }) => (
  <svg xmlns="http://www.w3.org/2000/svg" height={size} viewBox="0 -960 960 960" width={size} fill={fill}>
    <path d="m332-264 148-113 148 113-56-182 148-106H538l-58-192-58 192H240l148 106-56 182ZM480-96q-79 0-149-30t-122.5-82.5Q156-261 126-331T96-480q0-80 30-149.5t82.5-122Q261-804 331-834t149-30q80 0 149.5 30t122 82.5Q804-699 834-629.5T864-480q0 79-30 149t-82.5 122.5Q699-156 629.5-126T480-96Zm0-72q130 0 221-91t91-221q0-130-91-221t-221-91q-130 0-221 91t-91 221q0 130 91 221t221 91Zm0-312Z" />
  </svg>
);

export const VariantsIcon = ({ fill = "currentColor", size = 16 }) => (
  <svg xmlns="http://www.w3.org/2000/svg" height={size} viewBox="0 -960 960 960" width={size} fill={fill}>
    <path d="M408-48v-96H216q-29.7 0-50.85-21.15Q144-186.3 144-216v-528q0-29.7 21.15-50.85Q186.3-816 216-816h192v-96h72v864h-72ZM217-216h191v-227L217-216Zm335 72v-299l192 228v-529H552v-72h192q29.7 0 50.85 21.15Q816-773.7 816-744v528q0 29.7-21.15 50.85Q773.7-144 744-144H552Z" />
  </svg>
);

export const PercentIcon = () => (
  <svg width="36" height="37" viewBox="0 0 36 37" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M22.5 34.8359H13.5C5.355 34.8359 1.875 31.3559 1.875 23.2109V14.2109C1.875 6.06594 5.355 2.58594 13.5 2.58594H22.5C30.645 2.58594 34.125 6.06594 34.125 14.2109V23.2109C34.125 31.3559 30.645 34.8359 22.5 34.8359ZM13.5 4.83594C6.585 4.83594 4.125 7.29594 4.125 14.2109V23.2109C4.125 30.1259 6.585 32.5859 13.5 32.5859H22.5C29.415 32.5859 31.875 30.1259 31.875 23.2109V14.2109C31.875 7.29594 29.415 4.83594 22.5 4.83594H13.5Z"
      fill="url(#paint0_linear_521_36606)"
    />
    <path
      d="M12.8546 24.7392C12.5696 24.7392 12.2846 24.6342 12.0596 24.4092C11.6246 23.9742 11.6246 23.2542 12.0596 22.8192L21.8846 12.9942C22.3196 12.5592 23.0396 12.5592 23.4746 12.9942C23.9096 13.4292 23.9096 14.1492 23.4746 14.5842L13.6496 24.4092C13.4246 24.6342 13.1396 24.7392 12.8546 24.7392Z"
      fill="url(#paint1_linear_521_36606)"
    />
    <path
      d="M13.47 17.3775C11.835 17.3775 10.5 16.0425 10.5 14.4075C10.5 12.7725 11.835 11.4375 13.47 11.4375C15.105 11.4375 16.44 12.7725 16.44 14.4075C16.44 16.0425 15.105 17.3775 13.47 17.3775ZM13.47 13.7025C13.08 13.7025 12.75 14.0175 12.75 14.4225C12.75 14.8275 13.065 15.1425 13.47 15.1425C13.875 15.1425 14.19 14.8275 14.19 14.4225C14.19 14.0175 13.86 13.7025 13.47 13.7025Z"
      fill="url(#paint2_linear_521_36606)"
    />
    <path
      d="M23.28 25.9712C21.645 25.9712 20.3101 24.6362 20.3101 23.0012C20.3101 21.3662 21.645 20.0312 23.28 20.0312C24.915 20.0312 26.25 21.3662 26.25 23.0012C26.25 24.6362 24.915 25.9712 23.28 25.9712ZM23.28 22.2963C22.89 22.2963 22.5601 22.6112 22.5601 23.0162C22.5601 23.4212 22.875 23.7363 23.28 23.7363C23.685 23.7363 24 23.4212 24 23.0162C24 22.6112 23.685 22.2963 23.28 22.2963Z"
      fill="url(#paint3_linear_521_36606)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_521_36606"
        x1="1.875"
        y1="2.58594"
        x2="34.125"
        y2="36.4484"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#5e72e4" />
        <stop offset="1" stopColor="#825ee4" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_521_36606"
        x1="11.7334"
        y1="12.668"
        x2="23.8048"
        y2="25.339"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#5e72e4" />
        <stop offset="1" stopColor="#825ee4" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_521_36606"
        x1="10.5"
        y1="11.4375"
        x2="16.44"
        y2="17.6745"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#5e72e4" />
        <stop offset="1" stopColor="#825ee4" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_521_36606"
        x1="20.3101"
        y1="20.0313"
        x2="26.25"
        y2="26.2682"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#5e72e4" />
        <stop offset="1" stopColor="#825ee4" />
      </linearGradient>
    </defs>
  </svg>
);

export const NewEmailIcon = () => (
  <svg width="36" height="37" viewBox="0 0 36 37" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M25.5 32.5859H10.5C5.025 32.5859 1.875 29.4359 1.875 23.9609V13.4609C1.875 7.98594 5.025 4.83594 10.5 4.83594H21C21.615 4.83594 22.125 5.34594 22.125 5.96094C22.125 6.57594 21.615 7.08594 21 7.08594H10.5C6.21 7.08594 4.125 9.17094 4.125 13.4609V23.9609C4.125 28.2509 6.21 30.3359 10.5 30.3359H25.5C29.79 30.3359 31.875 28.2509 31.875 23.9609V16.4609C31.875 15.8459 32.385 15.3359 33 15.3359C33.615 15.3359 34.125 15.8459 34.125 16.4609V23.9609C34.125 29.4359 30.975 32.5859 25.5 32.5859Z"
      fill="url(#paint0_linear_521_40028)"
    />
    <path
      d="M17.9997 20.0161C16.7397 20.0161 15.4647 19.6261 14.4897 18.8311L9.79467 15.0811C9.31467 14.6911 9.22467 13.9861 9.61467 13.5061C10.0047 13.0261 10.7097 12.9361 11.1897 13.3261L15.8847 17.0761C17.0247 17.9911 18.9597 17.9911 20.0997 17.0761L21.8696 15.6661C22.3496 15.2761 23.0697 15.3511 23.4447 15.8461C23.8347 16.3261 23.7597 17.0461 23.2647 17.4211L21.4946 18.8311C20.5346 19.6261 19.2597 20.0161 17.9997 20.0161Z"
      fill="url(#paint1_linear_521_40028)"
    />
    <path
      d="M29.25 13.8359C26.565 13.8359 24.375 11.6459 24.375 8.96094C24.375 6.27594 26.565 4.08594 29.25 4.08594C31.935 4.08594 34.125 6.27594 34.125 8.96094C34.125 11.6459 31.935 13.8359 29.25 13.8359ZM29.25 6.33594C27.81 6.33594 26.625 7.52094 26.625 8.96094C26.625 10.4009 27.81 11.5859 29.25 11.5859C30.69 11.5859 31.875 10.4009 31.875 8.96094C31.875 7.52094 30.69 6.33594 29.25 6.33594Z"
      fill="url(#paint2_linear_521_40028)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_521_40028"
        x1="1.875"
        y1="4.83594"
        x2="29.1165"
        y2="38.0779"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#5e72e4" />
        <stop offset="1" stopColor="#825ee4" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_521_40028"
        x1="9.37061"
        y1="13.082"
        x2="14.6501"
        y2="24.5324"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#5e72e4" />
        <stop offset="1" stopColor="#825ee4" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_521_40028"
        x1="24.375"
        y1="4.08594"
        x2="34.125"
        y2="14.3234"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#5e72e4" />
        <stop offset="1" stopColor="#825ee4" />
      </linearGradient>
    </defs>
  </svg>
);

export const OpenedFileIcon = () => (
  <svg width="36" height="37" viewBox="0 0 36 37" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M22.5 34.8359H13.5C5.355 34.8359 1.875 31.3559 1.875 23.2109V14.2109C1.875 6.06594 5.355 2.58594 13.5 2.58594H22.5C30.645 2.58594 34.125 6.06594 34.125 14.2109V23.2109C34.125 31.3559 30.645 34.8359 22.5 34.8359ZM13.5 4.83594C6.585 4.83594 4.125 7.29594 4.125 14.2109V23.2109C4.125 30.1259 6.585 32.5859 13.5 32.5859H22.5C29.415 32.5859 31.875 30.1259 31.875 23.2109V14.2109C31.875 7.29594 29.415 4.83594 22.5 4.83594H13.5Z"
      fill="url(#paint0_linear_521_40020)"
    />
    <path
      d="M20.64 27.3359H15.345C13.695 27.3359 12.39 26.5259 11.655 25.0559L10.32 22.3709C10.005 21.7259 9.36 21.3359 8.64 21.3359H2.985C2.37 21.3359 1.86 20.8259 1.86 20.2109C1.86 19.5959 2.385 19.0859 3 19.0859H8.64C10.215 19.0859 11.625 19.9559 12.33 21.3659L13.665 24.0509C14.01 24.7409 14.565 25.0859 15.345 25.0859H20.64C21.36 25.0859 22.005 24.6959 22.32 24.0509L23.655 21.3659C24.36 19.9559 25.77 19.0859 27.345 19.0859H32.955C33.57 19.0859 34.08 19.5959 34.08 20.2109C34.08 20.8259 33.57 21.3359 32.955 21.3359H27.345C26.625 21.3359 25.98 21.7259 25.665 22.3709L24.33 25.0559C23.625 26.4659 22.215 27.3359 20.64 27.3359Z"
      fill="url(#paint1_linear_521_40020)"
    />
    <path
      d="M20.505 12.3359H15.51C14.88 12.3359 14.37 11.8259 14.37 11.2109C14.37 10.5959 14.88 10.0859 15.495 10.0859H20.49C21.105 10.0859 21.615 10.5959 21.615 11.2109C21.615 11.8259 21.12 12.3359 20.505 12.3359Z"
      fill="url(#paint2_linear_521_40020)"
    />
    <path
      d="M21.75 16.8359H14.25C13.635 16.8359 13.125 16.3259 13.125 15.7109C13.125 15.0959 13.635 14.5859 14.25 14.5859H21.75C22.365 14.5859 22.875 15.0959 22.875 15.7109C22.875 16.3259 22.365 16.8359 21.75 16.8359Z"
      fill="url(#paint3_linear_521_40020)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_521_40020"
        x1="1.875"
        y1="2.58594"
        x2="34.125"
        y2="36.4484"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#5e72e4" />
        <stop offset="1" stopColor="#825ee4" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_521_40020"
        x1="1.86"
        y1="19.0859"
        x2="5.66235"
        y2="34.6783"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#5e72e4" />
        <stop offset="1" stopColor="#825ee4" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_521_40020"
        x1="14.37"
        y1="10.0859"
        x2="15.5954"
        y2="14.2289"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#5e72e4" />
        <stop offset="1" stopColor="#825ee4" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_521_40020"
        x1="13.125"
        y1="14.5859"
        x2="14.0696"
        y2="18.8837"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#5e72e4" />
        <stop offset="1" stopColor="#825ee4" />
      </linearGradient>
    </defs>
  </svg>
);

export const NewFileIcon = () => (
  <svg width="36" height="37" viewBox="0 0 36 37" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M28.5 13.8359C25.395 13.8359 22.875 11.3159 22.875 8.21094C22.875 5.10594 25.395 2.58594 28.5 2.58594C31.605 2.58594 34.125 5.10594 34.125 8.21094C34.125 11.3159 31.605 13.8359 28.5 13.8359ZM28.5 4.83594C26.64 4.83594 25.125 6.35094 25.125 8.21094C25.125 10.0709 26.64 11.5859 28.5 11.5859C30.36 11.5859 31.875 10.0709 31.875 8.21094C31.875 6.35094 30.36 4.83594 28.5 4.83594Z"
      fill="url(#paint0_linear_514_42134)"
    />
    <path
      d="M18 21.3359H10.5C9.885 21.3359 9.375 20.8259 9.375 20.2109C9.375 19.5959 9.885 19.0859 10.5 19.0859H18C18.615 19.0859 19.125 19.5959 19.125 20.2109C19.125 20.8259 18.615 21.3359 18 21.3359Z"
      fill="url(#paint1_linear_514_42134)"
    />
    <path
      d="M24 27.3359H10.5C9.885 27.3359 9.375 26.8259 9.375 26.2109C9.375 25.5959 9.885 25.0859 10.5 25.0859H24C24.615 25.0859 25.125 25.5959 25.125 26.2109C25.125 26.8259 24.615 27.3359 24 27.3359Z"
      fill="url(#paint2_linear_514_42134)"
    />
    <path
      d="M22.5 34.8359H13.5C5.355 34.8359 1.875 31.3559 1.875 23.2109V14.2109C1.875 6.06594 5.355 2.58594 13.5 2.58594H21C21.615 2.58594 22.125 3.09594 22.125 3.71094C22.125 4.32594 21.615 4.83594 21 4.83594H13.5C6.585 4.83594 4.125 7.29594 4.125 14.2109V23.2109C4.125 30.1259 6.585 32.5859 13.5 32.5859H22.5C29.415 32.5859 31.875 30.1259 31.875 23.2109V15.7109C31.875 15.0959 32.385 14.5859 33 14.5859C33.615 14.5859 34.125 15.0959 34.125 15.7109V23.2109C34.125 31.3559 30.645 34.8359 22.5 34.8359Z"
      fill="url(#paint3_linear_514_42134)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_514_42134"
        x1="22.875"
        y1="2.58594"
        x2="34.125"
        y2="14.3984"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#5e72e4" />
        <stop offset="1" stopColor="#825ee4" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_514_42134"
        x1="9.375"
        y1="19.0859"
        x2="10.3196"
        y2="23.3837"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#5e72e4" />
        <stop offset="1" stopColor="#825ee4" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_514_42134"
        x1="9.375"
        y1="25.0859"
        x2="9.97683"
        y2="29.5094"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#5e72e4" />
        <stop offset="1" stopColor="#825ee4" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_514_42134"
        x1="1.875"
        y1="2.58594"
        x2="34.125"
        y2="36.4484"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#5e72e4" />
        <stop offset="1" stopColor="#825ee4" />
      </linearGradient>
    </defs>
  </svg>
);

export const RetailMediaIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.5 18.9596H7.50002C2.97502 18.9596 1.04169 17.0263 1.04169 12.5013V7.5013C1.04169 2.9763 2.97502 1.04297 7.50002 1.04297H12.5C17.025 1.04297 18.9584 2.9763 18.9584 7.5013V12.5013C18.9584 17.0263 17.025 18.9596 12.5 18.9596ZM7.50002 2.29297C3.65835 2.29297 2.29169 3.65964 2.29169 7.5013V12.5013C2.29169 16.343 3.65835 17.7096 7.50002 17.7096H12.5C16.3417 17.7096 17.7084 16.343 17.7084 12.5013V7.5013C17.7084 3.65964 16.3417 2.29297 12.5 2.29297H7.50002Z"
      fill="currentColor"
    />
    <path
      d="M13.6667 16.043H10.5C8.9 16.043 8.125 15.268 8.125 13.668V12.168C8.125 10.568 8.9 9.79297 10.5 9.79297H13.6667C15.2667 9.79297 16.0417 10.568 16.0417 12.168V13.668C16.0417 15.268 15.2667 16.043 13.6667 16.043ZM10.5 11.043C9.6 11.043 9.375 11.268 9.375 12.168V13.668C9.375 14.568 9.6 14.793 10.5 14.793H13.6667C14.5667 14.793 14.7917 14.568 14.7917 13.668V12.168C14.7917 11.268 14.5667 11.043 13.6667 11.043H10.5Z"
      fill="currentColor"
    />
  </svg>
);

export const WidgetIcon = ({ className }) => (
  <span className={className}>
    <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="currentColor">
      <path d="M666-440 440-666l226-226 226 226-226 226Zm-546-80v-320h320v320H120Zm400 400v-320h320v320H520Zm-400 0v-320h320v320H120Zm80-480h160v-160H200v160Zm467 48 113-113-113-113-113 113 113 113Zm-67 352h160v-160H600v160Zm-400 0h160v-160H200v160Zm160-400Zm194-65ZM360-360Zm240 0Z" />
    </svg>
  </span>
);

export const CropIcon = ({ size = 16 }) => (
  <svg xmlns="http://www.w3.org/2000/svg" height={size} viewBox="0 -960 960 960" width={size} fill="currentColor">
    <path d="M680-40v-160H280q-33 0-56.5-23.5T200-280v-400H40v-80h160v-160h80v640h640v80H760v160h-80Zm0-320v-320H360v-80h320q33 0 56.5 23.5T760-680v320h-80Z" />
  </svg>
);

export const ChevronDownIcon = ({ size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4 6.25L8 10.25L12 6.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
